module.exports = __webpack_public_path__ + "static/media/b10.53359785.jpg";